import { type ComputedRef, computed } from 'vue'

import { useShoppingAssistantWebSidebar } from '../stores/useShoppingAssistantWebSidebar'

import { useIsShoppingAssistantWebEnabled } from './useIsShoppingAssistantWebEnabled'

/**
 * Whether the shopping-assistant FAB is actually on screen right now: the
 * feature is enabled for this route/market, and the assistant isn't open —
 * the FAB hides itself (`v-show`) while its own panel/overlay is open, see
 * WebSidebarShoppingAssistantFAB.vue. Consumed cross-scope by unrelated
 * bottom-right popups that need to clear the FAB's footprint (see
 * useShoppingAssistantPopupOffset).
 */
export function useIsShoppingAssistantFabVisible(): ComputedRef<boolean> {
  const isEnabled = useIsShoppingAssistantWebEnabled()
  const store = useShoppingAssistantWebSidebar()

  return computed(() => isEnabled.value && !store.isOpen)
}
